// src/components/CustomColorPicker.tsx
import React from 'react';
import { frenchColorPalette, ColorInfo } from '../utils/colorPalette';
import { hexToHsl } from '../utils/colorUtils'; // Import hexToHsl
import { Box, ColorSwatch } from './ui';

interface CustomColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

const CustomColorPicker: React.FC<CustomColorPickerProps> = ({ value, onChange }) => {
  // Create a sorted copy of the color palette by HSL values
  const sortedPalette = [...frenchColorPalette].sort((a, b) => {
    const hslA = hexToHsl(a.hex);
    const hslB = hexToHsl(b.hex);

    // Sort by Hue (H), then Saturation (S), then Lightness (L)
    if (hslA.h !== hslB.h) {
      return hslA.h - hslB.h;
    }
    if (hslA.s !== hslB.s) {
      return hslA.s - hslB.s;
    }
    return hslA.l - hslB.l;
  });

  return (
    <Box
      bordered
      rounded
      padding={2}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(30px, 1fr))',
        gap: '8px',
      }}
    >
      {sortedPalette.map((color: ColorInfo) => {
        const isSelected = value.toLowerCase() === color.hex.toLowerCase();
        
        return (
          <ColorSwatch
            key={color.hex}
            color={color.hex}
            label={color.name}
            selected={isSelected}
            onClick={() => onChange(color.hex)}
          />
        );
      })}
    </Box>
  );
};

export default CustomColorPicker;
